module.exports = __webpack_public_path__ + "img/5.b9e5cc9e.jpg";